/**
 * Central feature flags for Farmly.
 * Reads from Vite env vars with safe defaults.
 */

function envBool(key: string, fallback = false): boolean {
  const val = import.meta.env[key];
  if (typeof val === 'string') {
    return val === '1' || val.toLowerCase() === 'true';
  }
  return fallback;
}

export const features = {
  /** Show tag-based place suggestions in Experience admin curation pages. */
  showTagSuggestions: envBool('VITE_FEATURE_TAG_SUGGESTIONS', false),
  /** Show "Gör mer av det här" context module on public place pages. */
  showPlaceContextModule: envBool('VITE_ENABLE_PLACE_CONTEXT_MODULE', true),
  /** Use canonical venue resolution (SoT) instead of legacy per-surface logic. */
  useEventVenueSoT: envBool('VITE_FEATURE_EVENT_VENUE_SOT', false),
  /** Enable Share Studio v1 for producers (activity sharing). */
  enableShareStudio: envBool('VITE_ENABLE_SHARE_STUDIO_V1', true),
} as const;
